<style lang="scss" scoped>
.search {
	&__container {
		@include flex-center;
	}
	&__exit {
		opacity: 0.4;
		&:hover {
			opacity: 1;
		}
	}
	&__input {
		width: 100%;
		margin-left: 14px;
		border: 0;
		font-size: 18px;
		&:focus {
			outline: 0;
		}
	}
}
</style>


<template lang="pug">
    .search(@click="focusInput()")
        panel.search__container
            img(src="@/assets/misc-icons/search.svg").search__icon
            input(placeholder="Search applications", ref="input", v-model="search").search__input
            img(src="@/assets/misc-icons/x.svg", @click="search = ''", v-if="search").search__exit

</template>

<script>
export default {
	computed: {
		search: {
			get() {
				return this.$route.query.search;
			},
			set(val) {
				this.$router.replace({ query: { search: val } });
			}
		}
	},

	methods: {
		focusInput() {
			this.$refs.input.focus();
		}
	}
};
</script>
